import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconHeader1 = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="13.395"
    height="13.422"
    viewBox="0 0 13.395 13.422"
    {...props}
  >
    <g transform="translate(-16 -29.578)">
      <path
        d="M10.8,0H8.383V-4.93H3.859V0H1.438V-11.422H3.859v4.477H8.383v-4.477H10.8Z"
        transform="translate(14.563 41)"
      />
      <path
        d="M2.256-.776A.683.683,0,0,0,2.384-.3a.612.612,0,0,0,.448.132V0q-.864-.032-1.1-.032-.264,0-1.152.024L.352,0V-.168A.92.92,0,0,0,.916-.312.609.609,0,0,0,1.1-.824V-2.776a1.716,1.716,0,0,0-.068-.564.385.385,0,0,0-.228-.24A1.481,1.481,0,0,0,.32-3.64v-.176a6.611,6.611,0,0,0,1.144-.108,2.483,2.483,0,0,0,.792-.3Z"
        transform="translate(26.563 43)"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconHeader1)
